export { default } from './ComposerSidebar.js';
